/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useCallback, useEffect, useRef } from "react";
import useState from "react-usestateref";
import { getRequest, putRequest } from "utils/request";
import { CircularProgress, Tooltip, makeStyles } from "@material-ui/core";
import EditClient from "./EditClient";
import EditTicket from "./EditTicket";
import SearchClient from "./SearchClient";
import { i18n } from "../../translate/i18n";
import { useNotification } from "hooks/notification";
import { useAuth } from "hooks/auth";
import { useModal } from "hooks/modal";
import FileTreatment from "components/FileTreatment";
import format from "utils/dateFormat";
import { SendTextAndMediaArea } from "./SendTextAndMediaArea";
import "./style.css";

const useStyles = makeStyles(() => ({
  customWidth: {
    fontSize: 16,
  },
}));

const SizeTextTab = 13;

export default function Chat({ history }) {
  const [ticketHistories, setTicketHistories] = useState([]);
  const [customer, setCustomer] = useState({});
  const [company, setCompany] = useState({});
  const [ticketStatus, setTicketStatus] = useState("");
  const [input, setInput] = useState("");
  const [companyStatus, setCompanyStatus] = useState("");
  const [listTickets, setListTickets, listTicketsRef] = useState([]);
  const [selectTicketId, setSelectTicketId, selectedTicketRef] = useState("");
  const [description, setDescription] = useState("");
  const [selectedTab, setSelectedTab, selectedTabRef] = useState(3);
  const [loadingListTicket, setLoadingListTicket] = useState(false);
  const [loadingdetails, setLoadingDetails] = useState(true);
  const [blockTicket, setBlockTicket] = useState(true);
  const [skuteTicket, setSkuteTicket] = useState(false);
  const [skuteChannelTicket, setSkuteChannelTicket] = useState(false);
  const [countshowaberto, setCountShowAberto] = useState(false);
  const [countAberto, setCountAberto] = useState(0);
  const [countAguardando, setCountAguardando] = useState(0);
  const [countAtendimento, setCountAtendimento] = useState(0);
  const [searchAttendant, setSearchAttendant] = useState(false);
  const [countFechado, setCountFechado] = useState(0);
  const [tabDetails, setTabDetails] = useState(1);
  const [ticketData, setTicketData] = useState({});
  const [listUser, setListUser] = useState([]);
  const [search, setSearch] = useState(false);
  const [offset, setOffset] = useState(0);
  const [more, setMore] = useState(0);
  const [searchTicket, setSearchTicket] = useState("");
  const [searchAttendantId, setSearchAttendantId] = useState("");
  const [searchParams, setSearchParams] = useState({});
  const [loading, setLoading] = useState(false);
  const [loadingMore, setLoadingMore] = useState(false);
  const { togglePhotoModal, toggleHelperId, ignoreQr } = useModal();
  const observer = useRef();

  const lastTicketRef = useCallback(
    (node) => {
      if (loading) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          setOffset(offset + Number(selectedCompany.ticketToShow));
        }
      });
      if (node) observer.current.observe(node);
    },
    [loading, more]
  );
  let bot;

  const { socket } = useAuth();

  const { user } = useAuth();

  const {
    selectedCompany,
    triggerUpdateNotificationCount,
    headerSelectedTicket,
    updateHeaderSelectedTicket,
    updateTicketList,
  } = useNotification();

  const classes = useStyles();

  // VERIFICAR SE TICKET FOI CLICADO NA HEADER
  // E CARREGA E SELECIONA O MESMO NO CHAT
  useEffect(() => {
    if (headerSelectedTicket?.id) {
      setSearch(true);
      setSearchTicket(headerSelectedTicket.ticket.ticket);

      setSelectTicketId(headerSelectedTicket.id);
      setLoadingDetails(true);

      getRequest(`/tickets/${headerSelectedTicket.id}`).then((ReturnGet) => {
        if (ReturnGet.success) {
          //Atualiza Count Notifications na Lista de Tickets
          if (ReturnGet.data.AgentId === user?.id) {
            //BAIXA NAS NOTIFICAÇÕES
            let newlist = listTickets;
            newlist.map((data) => {
              if (headerSelectedTicket.id === data.id) {
                updateNotification(headerSelectedTicket.id);
                return (data.notificationQuantity = 0);
              } else {
                return data;
              }
            });
          }

          //trocar tab e carregar os tickets da tab
          const status = ReturnGet.data.CompanyStatus.statusUser;
          setSelectedTab(status);
          setTimeout(() => {
            GetTickets(status, headerSelectedTicket.ticket);
          }, 500);
          //tratar interações do ticket
          handleValidTicket(ReturnGet.data);
          getConversation(headerSelectedTicket.id);

          //recarregar count
          loadTicketsCount(selectedCompany.id);

          //resetar ticket selecionado no header
          updateHeaderSelectedTicket(null);
        }
      });
    }
  }, [headerSelectedTicket]);

  useEffect(() => {
    // self: useffect caotico
    if (updateTicketList > 0) {
      listTickets.map((data) => {
        return (data.notificationQuantity = 0);
      });
      setListTickets([...listTickets]);
    }
  }, [updateTicketList]);

  useEffect(() => {
    if (!headerSelectedTicket) {
      //atualiza count de tickets nas tabs
      loadTicketsCount(selectedCompany.id);

      //Carrega lista de Tickets
      GetTickets(selectedTab);

      //reseta ticket selecionado
      setSelectTicketId(null);
    }

    getRequest(`/bots/config?CompanyId=${selectedCompany.id}`).then((e) => {
      if (e.success) {
        // self: bot sendo salvo em variavel comum ao inves de state ou ref
        bot = e.data;
      }
    });
  }, []);

  const listenToSocket = (notificationText) => {
    if (notificationText !== "logoff") {
      const isSelectedCompany =
        Number(selectedCompany.id) === Number(notificationText.CompanyId) ||
        (notificationText.skute === true && Number(selectedCompany.id) === 2); // SKUTE

      if (isSelectedCompany) {
        const selectedTab = selectedTabRef.current;
        let isSelectedTab;
        let isBot = bot?.id === notificationText?.AgentId;
        if (isBot) {
          isSelectedTab = true;
        } else {
          isSelectedTab =
            Number(selectedTab) ===
            Number(notificationText.CompanyStatus.statusUser);
        }

        if (isSelectedTab) {
          let insideList = false;

          const selectTicketId = selectedTicketRef.current;

          const isSelectedTicket =
            selectTicketId !== "" &&
            Number(selectTicketId) === Number(notificationText.id);

          //ATUALIZA COUNT DA LISTA DE TICKETS
          const newList = listTicketsRef.current.map((item) => {
            if (Number(item.id) === Number(notificationText.id)) {
              const updatedItem = {
                ...item,
                notificationQuantity:
                  isSelectedTicket && notificationText.AgentId === user?.id
                    ? 0
                    : notificationText.Notifications.length,
              };

              //APENAS DAR BAIXA NA NOTIFICAÇÃO SE O AGENTE DO TICKET FOR QUEM ESTA LOGADO.
              if (isSelectedTicket && notificationText.AgentId === user?.id) {
                updateNotification(item.id);
              }

              if (isSelectedTicket) {
                handleValidTicket(notificationText);
              }

              insideList = true;
              return updatedItem;
            }
            return item;
          });

          //VERIFICA SE O TICKET ESTÁ NA LISTA
          if (insideList) {
            //PEGA O INDEX DO TICKET NA LISTA
            const notificationIndex = newList.findIndex(
              (e) => Number(e.id) === Number(notificationText.id)
            );
            //VERIFICA SE O TICKET É DO AGENTE LOGADO
            if (notificationText.AgentId !== user.id && user.UserTypeId === 4) {
              //SE NÃO, RETIRA O TICKET
              if (notificationIndex !== -1) {
                newList.splice(notificationIndex, 1);
              }
            } else {
              newList.splice(notificationIndex, 1);
              newList.unshift({
                channelImage: notificationText.Channel.image,
                id: notificationText.id,
                CompanyName: notificationText.Company.nickName,
                DepartmentDescripion:
                  notificationText.CompanyDepartment.description,
                name: notificationText.Customer.name,
                notificationQuantity:
                  isSelectedTicket && notificationText.AgentId === user.id
                    ? 0
                    : notificationText.Notifications.length,
                photo: notificationText.Customer.photo,
                ticket: notificationText.ticket,
                skute: Boolean(notificationText.skute),
                Agent: notificationText.User?.nickName,
              });
            }
          } else {
            // ADICIONA O TICKET NA LISTA
            newList.unshift({
              channelImage: notificationText.Channel.image,
              id: notificationText.id,
              CompanyName: notificationText.Company.nickName,
              DepartmentDescripion:
                notificationText.CompanyDepartment.description,
              name: notificationText.Customer.name,
              notificationQuantity: notificationText.Notifications.length,
              photo: notificationText.Customer.photo,
              ticket: notificationText.ticket,
              skute: Boolean(notificationText.skute),
              Agent: notificationText.User?.nickName,
            });
          }

          setListTickets(newList);

          if (!isBot) {
            loadTicketsCount(selectedCompany.id);
          }
        } else {
          //SE NÃO TIVER NA TAB DO QUAL CHEGOU NOTIFICAÇÃO APENAS ATUALIZA OS COUNTS

          //VERIFICAR SE ESTAVA NESSA TAB ANTES DE TROCAR E SE SIM REMOVER
          const wasInsideList = listTicketsRef.current.some(
            (item) => item.id === notificationText.id
          );
          if (wasInsideList) {
            setListTickets((oldState) =>
              oldState.filter(
                (item) => Number(item.id) !== Number(notificationText.id)
              )
            );
          }
          if (!isBot) {
            loadTicketsCount(selectedCompany.id);
          }
        }
      }
    }
  };

  useEffect(() => {
    if (socket) {
      socket.on("notification", listenToSocket);
    }
  }, [socket]);

  const handleUpdate = () => {
    setSelectTicketId("");
    setTicketHistories([]);

    //atualiza count de tickets nas tabs
    loadTicketsCount(selectedCompany.id);

    GetTickets(selectedTab);
  };

  const loadTicketsCount = async (companyId) => {
    //Busca Count de Tickets por StatusTabs

    const ReturnGet = await getRequest(
      `tickets/countstatus?CompanyId=${companyId}&text=${searchTicket}&attendantId=${searchAttendantId}`
    );
    if (ReturnGet.success) {
      let listcountstatus = ReturnGet.data.list;

      setCountShowAberto(ReturnGet.data.openTicketShow);

      listcountstatus.forEach((item) => {
        if (item.statusUser === 1) {
          setCountAberto(item.quantity);
        } else if (item.statusUser === 2) {
          setCountAguardando(item.quantity);
        } else if (item.statusUser === 3) {
          setCountAtendimento(item.quantity);
        } else {
          setCountFechado(item.quantity);
        }
      });
    }
  };

  const GetTickets = async (status, text = "") => {
    setLoading(true);
    setListTickets([]);
    if (selectedTab !== status) setSelectedTab(status);
    setSearchParams({ status, text });
    const ReturnGet = await getRequest(
      `/tickets/status?CompanyId=${
        selectedCompany.id
      }&statusUser=${status}&text=${text}&offset=${0}&limit=${
        selectedCompany.ticketToShow
      }&attendantId=${searchAttendantId}`
    );

    if (ReturnGet.success) {
      if (ReturnGet.data) {
        //TODO
        setListTickets(ReturnGet.data);
        let data = ReturnGet.data;
        data.forEach((e) => {
          if (e.skute === 1) {
            e.skute = true;
          } else {
            e.skute = false;
          }
        });
        setListTickets(ReturnGet.data);
      }
      setLoadingListTicket(false);
    }
    setLoading(false);
  };

  const getUsers = async () => {
    await getRequest(`/tickets/staff/botAgent/${selectedCompany.id}`).then(
      function (response) {
        if (response.success) {
          setListUser(response.data);
        }
      }
    );
  };

  const getConversation = async (ticketid) => {
    setLoadingDetails(true);

    const ReturnGet = await getRequest(`/tickets/${ticketid}`);
    if (ReturnGet.success) {
      setSelectTicketId(ticketid);
      setTicketData(ReturnGet.data);
      //Atualiza Count Notifications na Lista de Tickets
      if (selectedTab !== 1 && ReturnGet.data.AgentId === user?.id) {
        //BAIXA NAS NOTIFICAÇÕES
        listTickets.map((data) => {
          if (ticketid === data.id) {
            if (data.notificationQuantity !== 0) {
              updateNotification(ticketid);
            }
            return (data.notificationQuantity = 0);
          } else {
            return data;
          }
        });
        setListTickets([...listTickets]);
      }
      handleValidTicket(ReturnGet.data);
    }
  };

  const loadMore = async (index) => {
    setLoadingMore(true);
    setTimeout(async () => {
      const { data } = await getRequest(
        `/tickets/status?CompanyId=${selectedCompany.id}&statusUser=${searchParams.status}&text=${searchParams.text}&offset=${index}&limit=${selectedCompany.ticketToShow}&attendantId=${searchAttendantId}`
      );
      let newList = [...listTickets, ...data];
      setListTickets(newList);
      if (data.length > 0) {
        setMore(more + 1);
      }
      setLoadingMore(false);
    }, 1000);
  };

  const updateNotification = async (value) => {
    await putRequest(`/notifications/${value}`);
    triggerUpdateNotificationCount();
  };

  const handleValidTicket = async (value) => {
    //4 Status Finalizado
    setCompanyStatus(Number(value.CompanyStatus.statusUser));
    if (
      Number(value.CompanyStatus.statusUser) === 4 ||
      Number(value.CompanyStatus.statusUser) === 1
    ) {
      setBlockTicket(true);
    } else {
      setBlockTicket(false);
    }
    // SE É UM TICKET SKUTE

    if (value.Channel.id === 3) {
      setSkuteChannelTicket(true);
    } else {
      setSkuteChannelTicket(false);
    }

    if (value.skute) {
      setSkuteTicket(true);
    } else {
      setSkuteTicket(false);
    }

    setCustomer(value.Customer);

    let newcompany = {
      id: value.Company.id,
      name: value.Company.nickName,
      photo: value.Company.pathLogo,
      updatedat: value.updatedAt,
      typeticket: value.ticketTypeDescription,
      ticket: value.ticket,
      skute: value.skute,
    };

    if (value.CompanyTicketType) {
      setDescription(value.CompanyTicketType.description);
    }

    setCompany(newcompany);
    setTicketStatus(value.CompanyStatus.id);

    setTicketHistories(value.TicketHistories);

    setLoadingDetails(false);

    // SCROLL ATÉ O FINAL DO TICKET
    const objDiv = document.getElementById("div-chat");
    if (objDiv) {
      objDiv.scrollTop = objDiv.scrollHeight;
    }
  };

  const handleClickTab = (tab, search) => {
    setOffset(0);
    setListTickets([]);
    setSelectTicketId("");
    setTicketStatus("");
    setInput("");
    setSelectedTab(tab);
    GetTickets(tab, search);

    //atualiza count de tickets nas tabs
    loadTicketsCount(selectedCompany.id);
  };

  const handleUpdateTicketUser = () => {
    getConversation(selectTicketId);
  };

  const handleSearch = () => {
    if (searchTicket.length > 0) {
      GetTickets(selectedTab, searchTicket);
      loadTicketsCount(selectedCompany.id);
    }
  };

  const handleSearchByAttendant = () => {
    if (!!searchAttendantId) {
      GetTickets(selectedTab, searchTicket);
      loadTicketsCount(selectedCompany.id);
    }
  };

  const handleInput = (data) => {
    setInput(data);
  };

  const handleTakeOn = async (id, ticket) => {
    // ASSUME TICKET
    const ReturnPut = await putRequest(`/tickets/takeon/${id}`);
    if (ReturnPut.success) {
      setSearch(true);
      setSearchTicket(ticket);
      setSelectedTab(3);

      setTimeout(() => {
        GetTickets(3, ticket);
      }, 1000);

      //atualiza count de tickets nas tabs
      loadTicketsCount(selectedCompany.id);
      getConversation(id);
    }
  };

  useEffect(() => {
    toggleHelperId(6);
    getUsers();
    GetTickets(selectedTab);
  }, []);

  useEffect(() => {
    if (selectedTab === 1) {
      setSearchAttendant(false);
      setSearchAttendantId("");
    }
  }, [selectedTab]);

  useEffect(() => {
    if (listTickets.length > 1) {
      loadMore(offset);
    }
  }, [offset]);

  useEffect(() => {
    if (search && searchAttendant) {
      setSearch(false);
      setSearchAttendant(false);
    }
  }, [search, searchAttendant]);

  return (
    <div
      style={{
        display: "flex",
        width: "100%",
        flexDirection: "column",
      }}
    >
      <div style={{ display: "flex", flexDirection: "row" }}>
        <div className="col-xl-3 col-lg-3 order-lg-1 order-xl-1">
          <div className="card" style={{ height: "78vh", marginBottom: 0 }}>
            <div className="card-body p-0">
              <ul
                style={{ display: "flex", justifyContent: "space-around" }}
                className="nav nav-tabs nav-bordered"
              >
                <Tooltip
                  arrow
                  classes={{ tooltip: classes.customWidth }}
                  title={i18n.t("inQueue")}
                >
                  <div>
                    <li
                      className="nav-item"
                      style={{ cursor: "pointer", fontSize: SizeTextTab }}
                      onClick={() => {
                        if (!countshowaberto) return;
                        handleClickTab(1);
                      }}
                    >
                      <a
                        data-toggle="tab"
                        aria-expanded="false"
                        className={
                          selectedTab === 1
                            ? "nav-link active py-2"
                            : "nav-link py-2"
                        }
                        style={{
                          display: "flex",
                          alignItems: "center",
                          padding: 0,
                        }}
                        onClick={(evt) => {
                          if (!countshowaberto) {
                            evt.preventDefault();
                            evt.stopPropagation();
                          }
                        }}
                      >
                        <span style={{ fontSize: 15 }}>
                          <i className="far fa-folder-open"></i>
                        </span>
                        <div className="area-count-tabs">
                          <strong>{countAberto}</strong>
                        </div>
                      </a>
                    </li>
                  </div>
                </Tooltip>

                <Tooltip
                  arrow
                  classes={{ tooltip: classes.customWidth }}
                  title={i18n.t("awaitingClient")}
                >
                  <li
                    className="nav-item"
                    style={{ cursor: "pointer", fontSize: SizeTextTab }}
                    onClick={() => {
                      handleClickTab(2);
                    }}
                  >
                    <a
                      data-toggle="tab"
                      aria-expanded="true"
                      className={
                        selectedTab === 2
                          ? "nav-link active py-2"
                          : "nav-link py-2"
                      }
                      style={{
                        display: "flex",
                        padding: 0,
                      }}
                    >
                      <span style={{ fontSize: 15 }}>
                        <i className="fas fa-mug-hot"></i>
                      </span>
                      <div className="area-count-tabs">
                        <strong>{countAguardando}</strong>
                      </div>
                    </a>
                  </li>
                </Tooltip>
                <Tooltip
                  arrow
                  classes={{ tooltip: classes.customWidth }}
                  title={i18n.t("inAttendance")}
                >
                  <li
                    className="nav-item"
                    style={{ cursor: "pointer", fontSize: SizeTextTab }}
                    onClick={() => {
                      handleClickTab(3);
                    }}
                  >
                    <a
                      data-toggle="tab"
                      aria-expanded="true"
                      className={
                        selectedTab === 3
                          ? "nav-link active py-2"
                          : "nav-link py-2"
                      }
                      style={{
                        display: "flex",
                        padding: 0,
                      }}
                    >
                      <span style={{ fontSize: 15 }}>
                        <i className="far fa-chart-bar"></i>
                      </span>
                      <div className="area-count-tabs">
                        <strong>{countAtendimento}</strong>
                      </div>
                    </a>
                  </li>
                </Tooltip>
                <Tooltip
                  arrow
                  classes={{ tooltip: classes.customWidth }}
                  title={i18n.t("closed")}
                >
                  <li
                    className="nav-item"
                    style={{ cursor: "pointer", fontSize: SizeTextTab }}
                    onClick={() => {
                      handleClickTab(4);
                    }}
                  >
                    <a
                      data-toggle="tab"
                      aria-expanded="true"
                      className={
                        selectedTab === 4
                          ? "nav-link active py-2"
                          : "nav-link py-2"
                      }
                      style={{
                        display: "flex",
                        padding: 0,
                      }}
                    >
                      <span style={{ fontSize: 15 }}>
                        <i className="fas fa-window-close"></i>
                      </span>
                      <div className="area-count-tabs">
                        <strong>{countFechado}</strong>
                      </div>
                    </a>
                  </li>
                </Tooltip>
                <div style={{ display: "flex" }}>
                  <Tooltip
                    arrow
                    classes={{ tooltip: classes.customWidth }}
                    title={i18n.t("search")}
                  >
                    <li
                      className="nav-item"
                      style={{ cursor: "pointer", fontSize: SizeTextTab }}
                      onClick={() => setSearch(!search)}
                    >
                      <div
                        data-toggle="tab"
                        aria-expanded="true"
                        style={{
                          display: "flex",
                          padding: "12px 0",
                        }}
                      >
                        <span
                          style={{ fontSize: 15, color: search && "#28b2bc" }}
                        >
                          <i className="fas fa-search"></i>
                        </span>
                      </div>
                    </li>
                  </Tooltip>
                  {selectedTab !== 1 &&
                    (user.UserTypeId === 1 ||
                      user.UserTypeId === 2 ||
                      user.UserTypeId === 3 ||
                      user.UserTypeId === 8 ||
                      user.UserTypeId === 9 ||
                      user.UserTypeId === 14 ||
                      user.UserTypeId === 15) && (
                      <Tooltip
                        arrow
                        classes={{ tooltip: classes.customWidth }}
                        title={i18n.t("searchPerAttendant")}
                      >
                        <li
                          className="nav-item"
                          style={{
                            cursor: "pointer",
                            fontSize: SizeTextTab,
                            marginLeft: 5,
                          }}
                          onClick={() => setSearchAttendant(!searchAttendant)}
                        >
                          <div
                            data-toggle="tab"
                            aria-expanded="true"
                            style={{
                              display: "flex",
                              padding: "12px 0",
                            }}
                          >
                            <span
                              style={{
                                fontSize: 15,
                                color: searchAttendant && "#28b2bc",
                              }}
                            >
                              <i className="fas fa-user"></i>
                            </span>
                          </div>
                        </li>
                      </Tooltip>
                    )}
                </div>
              </ul>
              <div className="tab-content">
                <div style={{ padding: "1vw" }} id="newpost">
                  <div
                    data-simplebar="init"
                    className="area-container-list-tickets-page-chat"
                  >
                    <div
                      className="simplebar-wrapper"
                      style={{ margin: 0, height: "69vh", marginBottom: 5 }}
                    >
                      <div className="simplebar-height-auto-observer-wrapper">
                        <div className="simplebar-height-auto-observer"></div>
                      </div>
                      <div className="simplebar-mask">
                        <div
                          className="simplebar-offset"
                          style={{
                            right: 0,
                            bottom: 0,
                          }}
                        >
                          <div
                            id="area-scroll-chat"
                            className="simple2bar-content-wrapper"
                            style={{
                              height: "100%",
                              overflow: "auto",
                              marginBottom: 10,
                            }}
                          >
                            <div
                              className="simplebar-content"
                              key={listTickets}
                            >
                              <div>
                                <div
                                  className="form-group"
                                  id="form-group-animation"
                                  style={{
                                    display: "flex",
                                    height: !search && 0,
                                    position: "fixed",
                                    width: "18%",
                                    zIndex: 100000,
                                  }}
                                >
                                  <input
                                    type="text"
                                    id="form-group-animation"
                                    className="form-control"
                                    value={searchTicket}
                                    placeholder={i18n.t("search")}
                                    style={{
                                      height: !search && 0,
                                      border: !search && "none",
                                      padding: !search && 0,
                                      borderTopRightRadius: 0,
                                      borderBottomRightRadius: 0,
                                    }}
                                    onChange={(e) =>
                                      setSearchTicket(e.target.value)
                                    }
                                  />
                                  {search && (
                                    <>
                                      <span
                                        onClick={() => {
                                          GetTickets(selectedTab, "");
                                          setSearchTicket("");
                                        }}
                                        style={{
                                          position: "absolute",
                                          right: 55,
                                          color: "red",
                                          top: 8,
                                          cursor: "pointer",
                                        }}
                                        className="mdi mdi-close"
                                      ></span>
                                      <div
                                        onClick={() => handleSearch()}
                                        className="btn-search-list-tickets"
                                      >
                                        <span className="mdi mdi-magnify search-icon"></span>
                                      </div>
                                    </>
                                  )}
                                </div>
                                <div
                                  className="form-group"
                                  id="form-group-animation"
                                  style={{
                                    display: "flex",
                                    height: !searchAttendant && 0,
                                    position: "fixed",
                                    width: "18%",
                                    zIndex: 100000,
                                  }}
                                >
                                  {/* TODO */}
                                  <select
                                    id="form-group-animation"
                                    className="form-control"
                                    value={searchAttendantId}
                                    placeholder={i18n.t("search")}
                                    style={{
                                      height: !searchAttendant && 0,
                                      border: !searchAttendant && "none",
                                      padding: !searchAttendant && 0,
                                      borderTopRightRadius: 0,
                                      borderBottomRightRadius: 0,
                                    }}
                                    onChange={(e) =>
                                      setSearchAttendantId(e.target.value)
                                    }
                                  >
                                    <option>{i18n.t("all")}</option>
                                    {listUser.map((data, index) => (
                                      <option key={index} value={data.id}>
                                        {data.nickName}
                                      </option>
                                    ))}
                                  </select>
                                  {searchAttendant && (
                                    <>
                                      <div
                                        onClick={() =>
                                          handleSearchByAttendant()
                                        }
                                        className="btn-search-list-tickets"
                                      >
                                        <span className="mdi mdi-magnify search-icon"></span>
                                      </div>
                                    </>
                                  )}
                                </div>
                              </div>
                              <div
                                className="text-body"
                                style={{
                                  marginTop: (search || searchAttendant) && 50,
                                }}
                              >
                                {!loadingListTicket ? (
                                  <div key={selectTicketId}>
                                    {listTickets.map((data, index) => {
                                      if (listTickets.length === index + 1) {
                                        return (
                                          <div
                                            ref={lastTicketRef}
                                            key={data.ticket}
                                            style={{
                                              cursor: "pointer",
                                              padding: "8px !important",
                                              backgroundColor:
                                                Number(selectTicketId) ===
                                                Number(data.id)
                                                  ? "lightblue"
                                                  : "none",
                                            }}
                                            className="media p-2"
                                            onClick={() => {
                                              if (
                                                data.channelImage.search(
                                                  "qrcode"
                                                ) >= 0 &&
                                                ignoreQr
                                              ) {
                                                alert(
                                                  "Usuário não logado no QrCode"
                                                );
                                                return;
                                              } else {
                                                getConversation(data.id);
                                              }
                                            }}
                                          >
                                            {!loadingMore ? (
                                              <>
                                                <FileTreatment
                                                  type={1}
                                                  src={data.channelImage}
                                                  className="img-icon-origin-chat"
                                                  alt="type"
                                                />
                                                <FileTreatment
                                                  type={1}
                                                  src={data.photo}
                                                  className="ticket-image"
                                                  height="50"
                                                  width="50"
                                                  alt="avatar"
                                                />
                                                <div className="media-body">
                                                  <div className="area-nome-count-chat-tickets">
                                                    <h5 className="mt-0 mb-0 font-14">
                                                      {data.name}
                                                    </h5>
                                                  </div>
                                                  <div className="mt-1 mb-0 text-muted font-12">
                                                    <div className="area-btn-assumir-chat">
                                                      <span className="w-65">
                                                        {data.ticket}
                                                        {data.skute ? (
                                                          <p
                                                            style={{
                                                              marginBottom: 0,
                                                            }}
                                                          >
                                                            {i18n.t("company")}:{" "}
                                                            {data.CompanyName}
                                                          </p>
                                                        ) : (
                                                          ""
                                                        )}
                                                        {user.UserTypeId !==
                                                        4 ? (
                                                          <p
                                                            style={{
                                                              marginBottom: 0,
                                                            }}
                                                          >
                                                            {i18n.t(
                                                              "department"
                                                            )}
                                                            :{" "}
                                                            {
                                                              data.DepartmentDescripion
                                                            }
                                                          </p>
                                                        ) : (
                                                          ""
                                                        )}
                                                        {data.Agent &&
                                                        user.UserTypeId !==
                                                          4 ? (
                                                          <p
                                                            style={{
                                                              marginBottom: 0,
                                                            }}
                                                          >
                                                            {i18n.t("operator")}
                                                            : {data.Agent}
                                                          </p>
                                                        ) : (
                                                          ""
                                                        )}
                                                      </span>
                                                      {data.notificationQuantity >
                                                        0 && (
                                                        <div className="area-count-list-tickets-chat">
                                                          <span className="text-count-list-tickets-chat">
                                                            {
                                                              data.notificationQuantity
                                                            }
                                                          </span>
                                                        </div>
                                                      )}
                                                      {selectedTab === 1 ? (
                                                        <button
                                                          className="btn-assumir-chat"
                                                          onClick={() =>
                                                            handleTakeOn(
                                                              data.id,
                                                              data.ticket
                                                            )
                                                          }
                                                        >
                                                          {i18n.t("assume")}
                                                        </button>
                                                      ) : (
                                                        <></>
                                                      )}
                                                    </div>
                                                  </div>
                                                </div>
                                              </>
                                            ) : (
                                              <div
                                                style={{
                                                  display: "flex",
                                                  justifyContent: "center",
                                                  alignItems: "center",
                                                  width: "100%",
                                                }}
                                              >
                                                <CircularProgress />
                                              </div>
                                            )}
                                          </div>
                                        );
                                      } else {
                                        return (
                                          <div
                                            key={data.ticket}
                                            style={{
                                              cursor: "pointer",
                                              padding: "8px !important",
                                              backgroundColor:
                                                Number(selectTicketId) ===
                                                Number(data.id)
                                                  ? "lightblue"
                                                  : "none",
                                            }}
                                            className="media p-2"
                                            onClick={() => {
                                              if (
                                                data.channelImage.search(
                                                  "qrcode"
                                                ) >= 0 &&
                                                ignoreQr
                                              ) {
                                                alert(
                                                  "Usuário não logado no QrCode"
                                                );
                                                return;
                                              } else {
                                                getConversation(data.id);
                                              }
                                            }}
                                          >
                                            <FileTreatment
                                              type={1}
                                              src={data.channelImage}
                                              className="img-icon-origin-chat"
                                              alt="type"
                                            />
                                            <FileTreatment
                                              type={1}
                                              src={data.photo}
                                              className="ticket-image"
                                              height="50"
                                              width="50"
                                              alt="avatar"
                                            />
                                            <div className="media-body">
                                              <div className="area-nome-count-chat-tickets">
                                                <h5 className="mt-0 mb-0 font-14">
                                                  {data.name}
                                                </h5>
                                              </div>
                                              <div className="mt-1 mb-0 text-muted font-12">
                                                <div className="area-btn-assumir-chat">
                                                  <span className="w-65">
                                                    {data.ticket}
                                                    {data.skute ? (
                                                      <p
                                                        style={{
                                                          marginBottom: 0,
                                                        }}
                                                      >
                                                        {i18n.t("company")}:{" "}
                                                        {data.CompanyName}
                                                      </p>
                                                    ) : (
                                                      ""
                                                    )}
                                                    {user.UserTypeId !== 4 ? (
                                                      <p
                                                        style={{
                                                          marginBottom: 0,
                                                        }}
                                                      >
                                                        {i18n.t("department")}:{" "}
                                                        {
                                                          data.DepartmentDescripion
                                                        }
                                                      </p>
                                                    ) : (
                                                      ""
                                                    )}
                                                    {data.Agent &&
                                                    user.UserTypeId !== 4 ? (
                                                      <p
                                                        style={{
                                                          marginBottom: 0,
                                                        }}
                                                      >
                                                        {i18n.t("operator")}:{" "}
                                                        {data.Agent}
                                                      </p>
                                                    ) : (
                                                      ""
                                                    )}
                                                  </span>
                                                  {data.notificationQuantity >
                                                    0 && (
                                                    <div className="area-count-list-tickets-chat">
                                                      <span className="text-count-list-tickets-chat">
                                                        {
                                                          data.notificationQuantity
                                                        }
                                                      </span>
                                                    </div>
                                                  )}
                                                  {selectedTab === 1 ? (
                                                    <button
                                                      className="btn-assumir-chat"
                                                      onClick={() =>
                                                        handleTakeOn(
                                                          data.id,
                                                          data.ticket
                                                        )
                                                      }
                                                    >
                                                      {i18n.t("assume")}
                                                    </button>
                                                  ) : (
                                                    <></>
                                                  )}
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        );
                                      }
                                    })}
                                  </div>
                                ) : (
                                  <div className="area-loading-list-tickets">
                                    <CircularProgress />
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="simplebar-placeholder"
                        style={{ width: "auto", height: 660 }}
                      ></div>
                    </div>
                    <div
                      className="simplebar-track simplebar-horizontal"
                      style={{ visibility: "hidden" }}
                    >
                      <div
                        className="simplebar-scrollbar"
                        style={{ width: 0, display: "none" }}
                      ></div>
                    </div>
                    <div
                      className="simplebar-track simplebar-vertical"
                      style={{ visibility: "visible" }}
                    >
                      <div
                        className="simplebar-scrollbar"
                        style={{
                          height: 458,
                          display: "block",
                        }}
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {!loadingdetails && (
          <>
            {selectTicketId && (
              <div className="col-xl-5 col-lg-5 order-lg-3 order-xl-1">
                <div
                  className="card"
                  style={{ height: "78vh", marginBottom: 0 }}
                >
                  <div className="container-area-chat-list">
                    <ul
                      className="conversation-list"
                      data-simplebar="init"
                      style={{
                        display: "flex",
                        height: "100%",
                        width: "100%",
                        marginBottom: 0,
                      }}
                    >
                      <div
                        className="simplebar-wrapper"
                        style={{ margin: 0 - 15 }}
                      >
                        <div className="simplebar-mask">
                          <div
                            className="simplebar-offset"
                            style={{ right: 0, bottom: 0 }}
                          >
                            <div className="text-scroll">
                              {ticketHistories ? (
                                <div
                                  className="simplebar-content"
                                  style={{ padding: 15 }}
                                  //corrigir  0 15
                                >
                                  {ticketHistories.map((data) => (
                                    <div key={data.id}>
                                      <li
                                        style={{
                                          paddingRight: !data.senderUser && 10,
                                          display: !data.visible && "none",
                                        }}
                                        className={
                                          data.senderUser
                                            ? "clearfix"
                                            : "clearfix odd"
                                        }
                                      >
                                        <Tooltip
                                          arrow
                                          classes={{
                                            tooltip: classes.customWidth,
                                          }}
                                          title={
                                            data.senderUser
                                              ? customer.name
                                              : data.User
                                              ? data.User.nickName
                                              : company.name
                                          }
                                          placement="top"
                                          onClick={() =>
                                            togglePhotoModal(
                                              data.senderUser
                                                ? customer.photo
                                                : data.User
                                                ? data.User.photo
                                                : company.photo
                                            )
                                          }
                                        >
                                          <div className="chat-avatar">
                                            <FileTreatment
                                              type={1}
                                              src={
                                                data.senderUser
                                                  ? customer.photo
                                                  : data.User
                                                  ? data.User.photo
                                                  : company.photo
                                              }
                                              className="rounded"
                                              alt="avatar-company"
                                            />
                                            <i>
                                              {format(
                                                data.createdAt,
                                                "HH:mm dd/MM/yy"
                                              )}
                                            </i>
                                          </div>
                                        </Tooltip>
                                        <div className="conversation-text">
                                          {data.typeFileId === 1 ? (
                                            <div
                                              style={{
                                                minHeight: 40,
                                                maxWidth: "80%",
                                              }}
                                              className="ctext-wrap"
                                            >
                                              <span
                                                tooltip="Oi"
                                                dangerouslySetInnerHTML={{
                                                  __html: data.message
                                                    .split("\n")
                                                    .join("<br/>"),
                                                }}
                                              ></span>
                                            </div>
                                          ) : (
                                            <>
                                              {data.typeFileId === 2 ? (
                                                <div
                                                  style={{
                                                    cursor: "pointer",
                                                  }}
                                                  onClick={() =>
                                                    window.open(
                                                      `${data.pathFile}`,
                                                      "_blank"
                                                    )
                                                  }
                                                >
                                                  <div className="card mb-1 shadow-none border text-left">
                                                    <div className="p-2">
                                                      <div className="row align-items-center">
                                                        <div className="col-auto">
                                                          <div className="avatar-sm">
                                                            <span className="avatar-title rounded">
                                                              {i18n.t(
                                                                "archive"
                                                              )}
                                                            </span>
                                                          </div>
                                                        </div>
                                                        <div className="col pl-0">
                                                          <a
                                                            href="#"
                                                            className="text-muted font-weight-bold"
                                                          >
                                                            {data.nameFile}
                                                          </a>
                                                        </div>
                                                        <div className="col-auto">
                                                          <a
                                                            href="#"
                                                            className="btn btn-link btn-lg text-muted"
                                                          >
                                                            <i className="dripicons-download"></i>
                                                          </a>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              ) : (
                                                <>
                                                  {data.typeFileId === 3 ? (
                                                    <div className="p-0">
                                                      <FileTreatment
                                                        type={1}
                                                        alt=""
                                                        className="img-chat-company-talk"
                                                        src={data.pathFile}
                                                        onPress={() =>
                                                          togglePhotoModal(
                                                            data.pathFile
                                                          )
                                                        }
                                                      />
                                                    </div>
                                                  ) : (
                                                    <>
                                                      {data.typeFileId === 4 ? (
                                                        <div className="p-0">
                                                          <FileTreatment
                                                            type={2}
                                                            controls
                                                            style={{
                                                              height: 200,
                                                            }}
                                                            controlsList="nodownload"
                                                            className="img-chat-company-talk"
                                                            src={data.pathFile}
                                                          />
                                                        </div>
                                                      ) : (
                                                        <div className="p-0">
                                                          <FileTreatment
                                                            type={3}
                                                            controls
                                                            style={{
                                                              minHeight: 60,
                                                            }}
                                                            controlsList="nodownload"
                                                            src={data.pathFile}
                                                          />
                                                        </div>
                                                      )}
                                                    </>
                                                  )}
                                                </>
                                              )}
                                            </>
                                          )}
                                        </div>
                                      </li>
                                    </div>
                                  ))}
                                </div>
                              ) : (
                                <></>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </ul>

                    <SendTextAndMediaArea
                      selectedTab={selectedTab}
                      user={user}
                      setTicketHistories={setTicketHistories}
                      blockTicket={blockTicket}
                      input={input}
                      setInput={setInput}
                      ticketData={ticketData}
                      customer={customer}
                      selectTicketId={selectTicketId}
                    />
                  </div>
                </div>
              </div>
            )}
          </>
        )}

        <div className="col-xl-4 col-lg-4 order-lg-3 order-xl-3">
          {selectTicketId ? (
            <div
              className="card"
              style={{ height: "78vh", overflow: "auto", marginBottom: 0 }}
            >
              <div className="card-body p-0">
                <ul className="nav nav-tabs nav-bordered">
                  <li
                    className="nav-item"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      setTabDetails(1);
                    }}
                  >
                    <div
                      data-toggle="tab"
                      aria-expanded="true"
                      style={{ paddingTop: "3px !important", paddingBottom: 5 }}
                      className={
                        tabDetails === 1
                          ? "nav-link active py-2"
                          : "nav-link py-2"
                      }
                    >
                      {i18n.t("callData")}
                    </div>
                  </li>
                  <li
                    className="nav-item"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      setTabDetails(2);
                    }}
                  >
                    <div
                      data-toggle="tab"
                      aria-expanded="true"
                      style={{ paddingTop: "3px !important", paddingBottom: 5 }}
                      className={
                        tabDetails === 2
                          ? "nav-link active py-2"
                          : "nav-link py-2"
                      }
                    >
                      {i18n.t("clientData")}
                    </div>
                  </li>
                </ul>

                <div className="tab-content">
                  <div style={{ padding: "1vw", paddingTop: 2 }} id="newpost">
                    <>
                      {!loadingdetails ? (
                        <>
                          {tabDetails === 1 ? (
                            <EditTicket
                              company={company}
                              setTicketData={setTicketData}
                              ticketData={ticketData}
                              handleTakeOn={handleTakeOn}
                              skuteChannelTicket={skuteChannelTicket}
                              selectTicketId={selectTicketId}
                              description={description}
                              handleUpdate={handleUpdate}
                              handleInput={handleInput}
                              ticketStatus={ticketStatus}
                              blockTicket={blockTicket}
                              skuteTicket={skuteTicket}
                              customer={customer}
                              setCustomer={setCustomer}
                              companyStatus={companyStatus}
                            />
                          ) : (
                            <>
                              {tabDetails === 2 ? (
                                <EditClient
                                  CustomerAllData={customer}
                                  setCustomer={setCustomer}
                                  skuteTicket={skuteTicket}
                                  skuteChannelTicket={skuteChannelTicket}
                                  ticketData={ticketData}
                                  insoftOpen={company.insoftOpen}
                                />
                              ) : (
                                <>
                                  {skuteTicket === false ? (
                                    <SearchClient
                                      CustomerAllData={customer}
                                      ticketid={selectTicketId}
                                      handleUpdateTicketUser={
                                        handleUpdateTicketUser
                                      }
                                    />
                                  ) : (
                                    <></>
                                  )}
                                </>
                              )}
                            </>
                          )}
                        </>
                      ) : (
                        <div className="mt-2">
                          <div className="container-data-tickets-area">
                            <div className="area-loading-details-profile">
                              <CircularProgress />
                            </div>
                          </div>
                        </div>
                      )}
                    </>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="card">
              <div className="card-body">
                <h4>{i18n.t("selectTicket")}</h4>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
